import { useState, useRef, useEffect } from "react";
import dayjs                           from "~/helpers/day";

export const useCallDuration = (call) => {
  const [duration, setDuration] = useState(0);
  let timeout = useRef().current;

  useEffect(() => {
    if (call) {
      timeout = setTimeout(() => {
        setDuration(duration + 1);
      }, 1000);
    } else {
      if (duration > 0) setDuration(0);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [call, duration, setDuration]);

  return {
    duration,
    callDuration: dayjs.duration(duration, "seconds").format("mm:ss"),
  };
};

export default useCallDuration;
